module.exports = __webpack_public_path__ + "img/212.non-sticky_carpet.09b99273.svg";